"use client";

import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { Button } from "@mozaic/ui/components/button";

// Route-level failure boundary: announced to assistive tech, focus moved to the message, with a retry.
export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations("errors");
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => heading.current?.focus(), []);
  return (
    <main id="main" className="mx-auto flex min-h-[60vh] max-w-md flex-col justify-center gap-4 px-4">
      <div role="alert" className="space-y-2">
        <h1 ref={heading} tabIndex={-1} className="text-xl font-semibold tracking-tight outline-none">
          {t("title")}
        </h1>
        <p className="text-sm text-muted-foreground">{t("description")}</p>
        {error.digest && (
          <p className="text-xs text-muted-foreground">
            {t("reference")}: <span dir="ltr">{error.digest}</span>
          </p>
        )}
      </div>
      <div className="flex gap-2">
        <Button onClick={reset}>{t("retry")}</Button>
        <Button asChild variant="outline">
          <Link href="/">{t("home")}</Link>
        </Button>
      </div>
    </main>
  );
}
